export default "/fonts/vendor/katex/dist/KaTeX_Main-BoldItalic.ttf?828abcb200061cffbaae1f0498f821a8";